export const faqs = [
  {
    question: "What is Easy Pairing?",
    answer: "Easy Pairing is an AI-powered platform that helps organizations create optimal groups & teams by pairing individuals based on compatibility, preferences, and shared characteristics. Using advanced AI algorithms, we help streamline the group formation process."
  },
  {
    question: "How accurate is the matching algorithm?",
    answer: "Our clustering algorithm has been extensively tested and refined to provide highly accurate matches based on the input data. The accuracy improves with the quality and quantity of responses to your customized questionnaires."
  },
  {
    question: "What size groups can I create?",
    answer: "You can create groups of any size, typically ranging from pairs to larger groups. The platform allows you to experiment with different group sizes and see various matching scenarios before finalizing your decisions."
  },
  {
    question: "How do I get started with Easy Pairing?",
    answer: "Getting started is simple: create an account, set up your first project, design your questionnaire, and share it with participants. Once responses are collected, you can generate and analyze different grouping scenarios."
  },
  {
    question: "Can I customize the questions for my specific needs?",
    answer: "Yes! Easy Pairing provides a flexible questionnaire builder where you can create custom questions specific to your organization's needs. You can include multiple question types such as multiple choice, and single choice."
  },
  {
    question: "How many questions should I include in my questionnaire?",
    answer: "We recommend a minimum of 15 carefully chosen questions for optimal results. However, you can include as many as needed to capture the essential matching criteria for your specific use case."
  },
  {
    question: "How is participant data protected?",
    answer: "We implement industry-standard security measures to protect all data. All information is encrypted, and we comply with major data protection regulations. We never share participant data with third parties."
  },
  {
    question: "Can participants see each other's responses?",
    answer: "No, individual responses remain confidential. Only the project administrator can see the full data, while participants only see their group assignments once they're finalized."
  },
  {
    question: "What happens if someone doesn't complete the questionnaire?",
    answer: "The system can still generate groups with partial data, but for best results, we recommend ensuring all participants complete the questionnaire. You can easily send reminders to those who haven't responded."
  },
  {
    question: "Can I modify a project after it's launched?",
    answer: "Yes, you can edit project settings and questionnaires until participants begin submitting responses. After responses begin coming in, certain modifications may be limited to preserve data integrity."
  },
  {
    question: "Can I save multiple grouping scenarios?",
    answer: "Yes, you can generate and save multiple grouping scenarios to compare different combinations and group sizes before making final decisions."
  },
  {
    question: "Is there a limit to how many projects I can create?",
    answer: "The number of projects you can create depends on your subscription plan. Free accounts have limited projects, while paid plans offer more flexibility and capacity."
  },
  {
    question: "Is there a free trial available?",
    answer: "Yes, we offer a free trial that includes all premium features, allowing you to fully evaluate the platform for your organization's needs."
  },
  {
    question: "Can I upgrade or downgrade my plan at any time?",
    answer: "Yes, you can change your subscription plan at any time. Changes take effect at the start of the next billing cycle, and pricing is adjusted accordingly."
  },
  {
    question: "Can I export the matching results?",
    answer: "Yes, you can export all matching results and group assignments in various formats (CSV, Excel, PDF) for easy integration with other systems or for record-keeping."
  }
];